// extracted by mini-css-extract-plugin
module.exports = {"bad":"Image-bad-2cf3","fit":"Image-fit-2cf3"};